const CHF = new Intl.NumberFormat('fr-CH', {
  style: 'currency',
  currency: 'CHF',
  maximumFractionDigits: 0,
});

const CHF_COMPACT = new Intl.NumberFormat('fr-CH', {
  style: 'currency',
  currency: 'CHF',
  notation: 'compact',
  maximumFractionDigits: 1,
});

/**
 * Format a CHF amount. `null` / `undefined` collapse to the empty string so
 * the pipeline table renders an empty cell when a computed value is missing
 * (per Excel reference spec — never "0", "-", "N/A").
 */
export function formatChf(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '';
  return CHF.format(value);
}

export function formatChfCompact(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '';
  return CHF_COMPACT.format(value);
}

/** Format a basis-points value. Returns empty string for null inputs. */
export function formatBps(roaBps: number | null | undefined): string {
  if (roaBps == null || !Number.isFinite(roaBps)) return '';
  return `${roaBps.toFixed(0)} bps`;
}
